import { MasonryPage } from 'components/masonry-page/masonry-page.component';
import { MASONRY } from 'common/constants';

// Wellness & Rewards benefits page (GEIS-307). Rendered entirely OOTB: the
// tree is server-driven and backed by a real resolver filtered to the
// `Wellness & Rewards` benefit category, so nothing here is conditional.
//
// The tree was built but never routed. It is reachable only by typing the URL
// until a CTA is authored to point at APP_MANAGED_ROUTES.WELLNESS_REWARDS.
//
// STR_WELLNESS_AND_REWARDS must stay byte-identical to the `heading` on the
// tree's own pageHeaderWeb (services#45975). Both this hook and the tree's
// root `setTitle` action write document.title through the same
// `DOCUMENT_TITLE` intl wrapper, and setTitle fires later — after the async
// tree resolves — so it wins. Matching literals make the two writes identical
// instead of a visible retitle. See wellness-rewards.page.test.tsx.
export const WellnessRewardsPage = () => (
  <MasonryPage
    screenName="Wellness & Rewards"
    titleMessageId="STR_WELLNESS_AND_REWARDS"
    rootNodeId={MASONRY.ROOT_NODE_ID_WELLNESS_REWARDS}
  />
);
